import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { useQuery } from 'data-fetching-client';
import { GET_PORTAL_DATA_QUERY } from 'customer-portal-app/__generated__/chirp/com/hubspot/support/portal/rpc/PortalDataRpc.dfc.new';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
export const usePortalData = () => {
  const preview = getIsPreview();
  const _useQuery = useQuery(GET_PORTAL_DATA_QUERY, {
      variables: preview.isPreview ? {
        previewJwt: preview.previewJwt
      } : {}
    }),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result,
    refetch,
    loading
  }, rest);
};
export const useConfiguredTicketListProperties = () => {
  const {
    data
  } = usePortalData();
  return data === null || data === void 0 ? void 0 : data.configuredTicketListProperties;
};
export const useConfiguredTicketDetailProperties = () => {
  const {
    data
  } = usePortalData();
  return data === null || data === void 0 ? void 0 : data.configuredTicketDetailProperties;
};